@if (group !='customer') {
  <div class="box box-success">
    <div class="box-header with-border">
      <div class="form-group">
        <h3 class="box-title" style="display: inline;">Summary</h3>
        <input placeholder="Choose date range" class="form-control" style="display: inline;width: 25%; margin-left: 1em;"
          [ngModelOptions]="{standalone: true}" #drp="bsDaterangepicker" [bsConfig]="bsConfig" bsDaterangepicker
          [(ngModel)]="dashboardDate" (ngModelChange)="onDashboardDateRangeChanged()" readonly>
        <button class="btn btn-danger pull-right" (click)="resetDate()">Reset Date</button>
      </div>
    </div>
    <div class="box-body">
      <div class="row">
        @if (group != groupTypes.CUSTOMER&&group != groupTypes.FINANCE) {
          <div class="col-lg-3 col-xs-6">
            <!-- small box -->
            <div class="small-box bg-aqua">
              <div class="inner">
                @if (dashboardData) {
                  <h3>{{dashboardData?.parking_places }}</h3>
                }
                @if (!dashboardData) {
                  <i class="fa fa-arrow-circle-right"></i>
                }
                <p>Places</p>
              </div>
              <div class="icon">
                <i class="ion ion-map"></i>
              </div>
              <a routerLink="../parkingplaces" class="small-box-footer">More info
                <i class="fa fa-arrow-circle-right"></i>
              </a>
            </div>
          </div>
        }
        <!-- ./col -->
        @if (group == groupTypes.ADMIN) {
          <div class="col-lg-3 col-xs-6">
            <!-- small box -->
            <div class="small-box bg-aqua">
              <div class="inner">
                <h3>{{dashboardData?.transaction_amount | number:'1.3'}} KD</h3>
                <p>Top up</p>
              </div>
              <div class="icon">
                <i class="fa fa-credit-card"></i>
              </div>
              <a routerLink="../reports/topups" class="small-box-footer">More info
                <i class="fa fa-arrow-circle-right"></i>
              </a>
            </div>
          </div>
        }
        <!-- ./col -->
        @if (group == groupTypes.ADMIN || group == groupTypes.SUPPORTUSER) {
          <div class="col-lg-3 col-xs-6">
            <!-- small box -->
            <div class="small-box bg-aqua">
              <div class="inner">
                <h3>{{dashboardData?.users}}</h3>
                <p>User Registrations</p>
              </div>
              <div class="icon">
                <i class="ion ion-person"></i>
              </div>
              <a routerLink="../users" class="small-box-footer">More info
                <i class="fa fa-arrow-circle-right"></i>
              </a>
            </div>
          </div>
        }
        <!-- ./col -->
        @if (group != groupTypes.CUSTOMER) {
          <div class="col-lg-3 col-xs-6">
            <!-- small box -->
            <div class="small-box bg-aqua">
              <div class="inner">
                <h3>{{dashboardData?.parking_logs}}</h3>
                <p>Tickets</p>
              </div>
              <div class="icon">
                <i class="fa fa-ticket"></i>
              </div>
              <a routerLink="../reports/pass_tickets" class="small-box-footer">More info
                <i class="fa fa-arrow-circle-right"></i>
              </a>
            </div>
          </div>
        }
        <!-- ./col -->
      </div>
    </div>
    @if (loading) {
      <div class="overlay">
        <i class="fa fa-refresh fa-spin"></i>
      </div>
    }
  </div>
}